// Formatting shared by the Airwallex Balance screens. The API sends SGD
// amounts as numbers or "12.34" strings and times as "YYYY-MM-DD HH:mm:ss"
// in Singapore time, which is shown as is (never converted to the browser's zone).
import moment from "moment";

export const money = (value, signed = false) => {
  if (value === null || value === undefined || value === "") return "—";
  const number = Number(value);
  const text = "S$" + Math.abs(number).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  if (number < 0) return "−" + text;
  return signed && number > 0 ? "+" + text : text;
};

export const dateTime = (value) => (value ? moment(value, "YYYY-MM-DD HH:mm:ss").format("D MMM, HH:mm") : "—");

export const dateLong = (value) => (value ? moment(value, "YYYY-MM-DD HH:mm:ss").format("D MMM YYYY, HH:mm") : "—");

export const dateShort = (value) => (value ? moment(value, "YYYY-MM-DD").format("D MMM") : "");

export const methodLabel = (method) => {
  if (!method) return "—";
  if (method === "pay_now") return "PayNow";
  if (method === "card" || method === "card_present") return "Card";
  return method.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
};

// What the row is called in the portal (category from the API).
export const typeKey = {
  payment: "airwallexBalance.typePayment",
  payout: "airwallexBalance.typePayout",
  refund: "airwallexBalance.typeRefund",
  other: "airwallexBalance.typeOther",
};

// Status label. A payout follows its bank transfer (the wallet is debited at
// once): Sent until the bank pays it, then Paid, or Failed. A settled refund is "Taken back".
const PAYOUT_STATE_KEYS = {
  sent: "airwallexBalance.statusSent",
  paid: "airwallexBalance.statusPaid",
  failed: "airwallexBalance.statusFailed",
};

export const statusKey = (row) => {
  if (row.status === "PROCESSING") return "airwallexBalance.statusProcessing";
  if (row.status === "PENDING") return "airwallexBalance.statusPending";
  if (row.status === "CANCELLED") return "airwallexBalance.statusCancelled";
  if (row.category === "payout") return PAYOUT_STATE_KEYS[row.payout_state] || PAYOUT_STATE_KEYS.sent;
  if (row.category === "refund") return "airwallexBalance.statusTakenBack";
  return "airwallexBalance.statusSettled";
};

export const statusClass = (row) => {
  if (row.category === "payout" && row.payout_state === "failed") return "awb-badge--bad";
  if (row.status === "PROCESSING" || row.status === "PENDING" || (row.category === "payout" && row.payout_state !== "paid")) return "awb-badge--pending";
  if (row.status === "CANCELLED") return "awb-badge--muted";
  return "awb-badge--ok";
};

// Processing rows (paid, not in the wallet history yet) have no id: no detail to open.
export const rowKey = (row) => (row.id ? row.id : "p-" + row.payment_intent_id);

// Order id for a payment/refund; for a payout the reference Airwallex puts in
// brackets ("Pay 101.88 SGD to X (Daily sweep 24/10/2026)"); else the description.
export const rowRef = (row) => {
  if (row.transaction_id) return row.transaction_id;
  const reference = row.category === "payout" && (row.description || "").match(/\(([^()]+)\)\s*$/);
  return reference ? reference[1] : row.description || "—";
};
